import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getVacancies({ payload }) {
  try {
    const { data, status } = yield call(api.vacancies.getVacancies, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_VACANCIES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_VACANCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getSingleVacancy({ payload }) {
  try {
    const { data, status } = yield call(api.vacancies.getSingleVacancy, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_SINGLE_VACANCY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_SINGLE_VACANCY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createVacancies({ payload, callback }) {
  try {
    const { data, status } = yield call(api.vacancies.createVacancies, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_VACANCIES_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_VACANCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateVacancies({ payload, callback }) {
  try {
    const { status } = yield call(api.vacancies.updateVacancies, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_VACANCIES_SUCCESS });
    yield put({ type: types.GET_VACANCIES_START });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_VACANCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteVacancies({ payload }) {
  try {
    const { status } = yield call(api.vacancies.deleteVacancies, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_VACANCIES_SUCCESS, payload: payload.id });
  } catch (error) {
    yield put({ type: types.DELETE_VACANCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* vacancies() {
  yield all([
    takeLatest(types.GET_VACANCIES_START, getVacancies),
    takeLatest(types.GET_SINGLE_VACANCY_START, getSingleVacancy),
    takeLatest(types.CREATE_VACANCIES_START, createVacancies),
    takeLatest(types.UPDATE_VACANCIES_START, updateVacancies),
    takeLatest(types.DELETE_VACANCIES_START, deleteVacancies),
  ]);
}
